import { Component, OnDestroy } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Observable, of, Subject } from 'rxjs';
import { filter, map, mergeMap, takeUntil } from 'rxjs/operators';
import { getLastChildRoute } from '../../../shared/helpers/base-get-last-route-child';
import { BasePageTitleService } from '../../../shared/services/base-page-title.service';
import { BasePageTitleData } from '../../../shared/interfaces/base-page-title-data.interface';

@Component({
  selector: 'base-page-title',
  templateUrl: './base-page-title.component.html',
})
export class BasePageTitleComponent implements OnDestroy {
  title: string;
  titleTranslateParams: Record<string, string>;
  private destroy$: Subject<void> = new Subject();

  constructor(
    public activatedRoute: ActivatedRoute,
    private router: Router,
    private basePageTitleService: BasePageTitleService
  ) {
    this.setTitleData();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private setTitleData(): void {
    this.router.events
      .pipe(
        takeUntil(this.destroy$),
        filter((event) => event instanceof NavigationEnd),
        map(() => getLastChildRoute(this.activatedRoute).snapshot),
        mergeMap(({ data }) => {
          if (data?.title) {
            return of({ title: data.title, translateParams: {} }) as Observable<BasePageTitleData>;
          } else {
            return this.basePageTitleService.titleData$;
          }
        })
      )
      .subscribe((titleData) => {
        this.title = titleData.title || '';
        this.titleTranslateParams = titleData.translateParams || {};
      });
  }
}
